exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".see-all[data-v-1fd4e852] {\n  text-align: center;\n  margin-top: 10px;\n  color: #13ce67;\n}", ""]);

// exports
